export function hasNumber(myString: string): boolean {
    return /\d/.test(myString);
}
